<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center mt-4">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Transactions</h1>
        <p class="mt-2 text-sm text-gray-700">
          A list of all the Transactions
        </p>
      </div>
    </div>
    <!-- Filters Section -->
    <div
      class="flex flex-wrap items-center justify-between py-4 space-y-2 sm:space-y-0 sm:space-x-4 ml-4 mr-4 mt-2 bg-white rounded-lg"
    >
      <!-- Customer Name Filter -->
      <div class="flex items-center space-x-2 px-3">
        <label for="customer-name" class="text-sm font-medium text-gray-700">
          Customer Name:
        </label>
        <input
          id="customer-name"
          v-model="filters.name"
          @input="applyFilters"
          type="text"
          placeholder="Enter customer name"
          class="px-3 py-2 border rounded shadow-sm focus:ring focus:ring-blue-200"
        />
      </div>

      <!-- Date Range Filter -->
      <div class="flex items-center space-x-2">
        <label for="start-date" class="text-sm font-medium text-gray-700">
          Date Range:
        </label>
        <input
          type="date"
          id="start-date"
          v-model="filters.startDate"
          class="px-3 py-2 border rounded shadow-sm focus:ring focus:ring-blue-200"
          @input="applyFilters"
        />
        <span>to</span>
        <input
          type="date"
          id="end-date"
          v-model="filters.endDate"
          class="px-3 py-2 border rounded shadow-sm focus:ring focus:ring-blue-200"
          @input="applyFilters"
        />
      </div>

      <!-- Reset Filters -->
      <button
        @click="resetFilters"
        class="px-4 py-2 text-sm font-medium text-white bg-primary rounded shadow-sm hover:bg-primary mr-2"
      >
        Reset Filters
      </button>
    </div>

    <div class="px-4 sm:px-6 lg:px-8">
      <div class="mt-4 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
          >
            <div
              class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Customer Name
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Discount
                    </th>

                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Payment Mode
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="item in transactions" :key="item.id">
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{
                        new Date(
                          item.transaction_date + "Z"
                        ).toLocaleDateString("en-CA", {
                          timeZone: "UTC"
                        })
                      }}
                    </td>
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                    >
                      {{ item.customer_name }}
                      <div class="">
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                        >
                          {{ item.transaction_type }}
                        </span>
                      </div>
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{ item.amount | currency }}
                    </td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{ item.discount }}
                    </td>

                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      {{ item.payment_mode }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="flex items-center justify-between px-4 mt-4 bg-white p-2 rounded-lg"
            >
              <!-- Records Per Page Selector -->
              <div class="flex items-center space-x-2">
                <label for="per-page" class="text-sm font-medium"
                  >Records per page:</label
                >
                <select
                  id="per-page"
                  v-model="perPage"
                  @change="getTransactions()"
                  class="px-2 py-1 border rounded"
                >
                  <option
                    v-for="option in perPageOptions"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>

              <Pagination
                :currentPage="pagination.current_page"
                :totalPages="pagination.last_page"
                @page-change="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";

export default {
  data() {
    return {
      transactions: [],
      pagination: {},
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      filters: {
        name: "",
        startDate: "",
        endDate: ""
      },
      paginationLinks: []
    };
  },
  components: {
    Pagination
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  mounted() {
    this.getTransactions();
  },

  methods: {
    applyFilters() {
      const { name, startDate, endDate } = this.filters;
      let url = `/api/v1/transactions?page=1&per_page=${this.perPage}`;
      if (name) url += `&name=${encodeURIComponent(name)}`;
      if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`;
      if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`;
      this.getTransactions(url);
    },
    resetFilters() {
      this.filters.name = "";
      this.filters.startDate = "";
      this.filters.endDate = "";
      this.getTransactions();
    },

    handlePageChange(page) {
      const { name, startDate, endDate } = this.filters;
      let url = `/api/v1/transactions?page=${page}&per_page=${this.perPage}`;
      if (name) url += `&name=${encodeURIComponent(name)}`;
      if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`;
      if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`;
      this.getTransactions(url);
    },

    getTransactions(
      url = `/api/v1/transactions?page=1&per_page=${this.perPage}`
    ) {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(response => {
          this.transactions = response.data.data;
          this.pagination = {
            current_page: response.data.current_page,
            prev_page_url: response.data.prev_page_url,
            next_page_url: response.data.next_page_url,
            last_page: response.data.last_page
          };
          this.generatePaginationLinks();
        });
    },
    generatePaginationLinks() {
      const links = [];
      for (let i = 1; i <= this.pagination.last_page; i++) {
        links.push({
          number: i,
          url: `/api/v1/transactions?page=${i}&per_page=${this.perPage}`,
          active: i === this.pagination.current_page
        });
      }
      this.paginationLinks = links;
    }
  }
};
</script>
